import script from "./AdvancedTextAreaField.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvancedTextAreaField.vue?vue&type=script&lang=ts&setup=true"

import "./AdvancedTextAreaField.vue?vue&type=style&index=0&id=1cf3720f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf3720f"]])

export default __exports__